import { useState } from "react";
import { AlertTriangle, CheckCircle2 } from "lucide-react";
import { Reveal, Eyebrow, SectionTitle } from "./Reveal";
import { RISK_POINTS } from "@/data/content";

export default function RiskDisclosure() {
  const [ack, setAck] = useState(false);

  return (
    <section
      id="risk"
      data-testid="risk-disclosure-container"
      className="relative border-y border-brand/25 bg-surface py-24"
    >
      <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-brand to-transparent" />
      <div className="mx-auto max-w-5xl px-4 sm:px-6">
        <Reveal>
          <div className="text-center">
            <Eyebrow>Compliance & Transparency</Eyebrow>
            <SectionTitle className="mt-3">
              Understanding <span className="text-brand">Investment Risks</span>
            </SectionTitle>
          </div>
        </Reveal>

        <Reveal delay={0.1}>
          <p className="mx-auto mt-8 max-w-3xl text-center text-sm leading-relaxed text-mute sm:text-base">
            Investing in financial markets involves risk. The value of
            investments can rise or fall, and investors may lose part or all of
            their invested capital. Market performance is not guaranteed, and
            past performance does not predict future results. Before making any
            investment decisions, individuals should carefully assess their
            financial situation, conduct independent research, and consult
            qualified financial professionals where appropriate.
          </p>
        </Reveal>

        <Reveal delay={0.18}>
          <div className="mt-10 rounded-2xl border border-brand/35 bg-panel p-7 sm:p-9">
            <div className="flex items-center gap-3">
              <span className="pulse-red flex h-9 w-9 items-center justify-center rounded-full bg-brand/15">
                <AlertTriangle size={17} className="text-brand" />
              </span>
              <h3 className="font-display text-xl font-black uppercase tracking-wide text-ink sm:text-2xl">
                Important Notice
              </h3>
            </div>
            <ul className="mt-6 grid gap-3 sm:grid-cols-2">
              {RISK_POINTS.map((p) => (
                <li key={p} className="flex items-start gap-2.5 text-sm text-mute">
                  <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-brand" />
                  {p}
                </li>
              ))}
            </ul>
            <button
              data-testid="risk-acknowledge-toggle"
              onClick={() => setAck((a) => !a)}
              className={`mt-8 inline-flex items-center gap-2.5 rounded-full border px-6 py-3 font-mono text-[11px] font-bold uppercase tracking-[0.18em] transition-colors duration-300 ${
                ack
                  ? "border-up/50 bg-up/10 text-up"
                  : "border-line text-mute hover:border-brand hover:text-brand"
              }`}
            >
              {ack ? <CheckCircle2 size={15} /> : <AlertTriangle size={15} />}
              {ack ? "Risks Acknowledged" : "I Understand the Risks"}
            </button>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
